import React, { createContext, useContext, useEffect, useState } from "react";
import apiExports from "../services/api";

const UserContext = createContext(null);

export function UserProvider({ children }) {
    const [user, setUser] = useState(null);
    const [audience, setAudience] = useState({ tier: "guest", show_ads: true, is_authenticated: false });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;
        (async () => {
            try {
                const res = await apiExports.users.getCurrentUser();
                if (!isMounted) return;
                setUser(res.data.user);
                setAudience(res.data.audience || { tier: "guest", show_ads: true, is_authenticated: false });
            } catch (e) {
                if (!isMounted) return;
                setUser(null);
                setAudience({ tier: "guest", show_ads: true, is_authenticated: false });
            } finally {
                if (isMounted) setLoading(false);
            }
        })();
        return () => { isMounted = false; };
    }, []);

    return (
        <UserContext.Provider value={{ user, audience, loading, setUser, setAudience }}>
            {children}
        </UserContext.Provider>
    );
}

export function useUser() {
    return useContext(UserContext);
}
